import { useFlags } from "launchdarkly-react-client-sdk";

import { useSpaceContext } from "src/components/spaces";

// A helper to check if usage can be shown.
export function useIsUsageEnabled(): boolean {
  const { lineageGraphUsage } = useFlags();
  // Lineage isn't supported in spaces.
  const { isInSpace } = useSpaceContext();

  return Boolean(lineageGraphUsage) && !isInSpace;
}
